import type { ReactNode } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface LayoutProps {
  children: ReactNode;
  overlayNav?: boolean;
}

export default function Layout({
  children,
  overlayNav = false,
}: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-950">
      <Navbar overlay={overlayNav} />
      <main className={`flex-1 ${overlayNav ? "" : "pt-16 md:pt-[72px]"}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}